// WARNING: DO NOT EDIT.  This file is automatically generated
// Written by aws-amplify-serverless-plugin/1.4.2 on 2020-08-18T13:51:44.246Z

const awsmobile = {
    aws_cloud_logic_custom: [
        {
            endpoint: 'https://cvjwatnr9l.execute-api.us-west-2.amazonaws.com/prod',
            name: 'ApiGatewayRestApi',
            region: 'us-west-2'
        }
    ],
    aws_cognito_identity_pool_id: 'us-west-2:059154d1-e29c-4fa9-b6c6-b3ef31c58f9c',
    aws_cognito_region: 'us-west-2',
    aws_project_region: 'us-west-2',
    aws_user_pools_id: 'us-west-2_FO7YPB5Nv',
    aws_user_pools_web_client_id: '5kkf6pajc19ls03crgbmauf5sp'
};

export default awsmobile;
